export const subscriptionsBaseApiUrl = process.env.REACT_APP_SUBSCRIBER_API_URL ?? "/api-subscriber/api";
